import { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useSnackbar } from 'notistack';
import { logout } from '../auth/auth';

const messages = defineMessages({
  failed: {
    id: 'auth.logout_failed',
    defaultMessage: 'Logout failed. Check your connection and try again.',
  },
});

export const useLogout = (): (() => void) => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();

  return useCallback(() => {
    void logout().catch(() => {
      enqueueSnackbar(intl.formatMessage(messages.failed), {
        variant: 'error',
        preventDuplicate: true,
      });
    });
  }, [enqueueSnackbar, intl]);
};
